<template>
  <zj-layout-container>
    <zj-layout-header v-if="isHeadVisiable">
      <div class="listtitle">通讯录详情</div>
    </zj-layout-header>
    <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
      <div class="zj-layout-main-content bgcolor scrollable">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="姓名" prop="name" style="display:inline-block;">
          <el-input v-model="ruleForm.name" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="年龄" prop="age" style="display:inline-block;">
          <el-input v-model="ruleForm.age" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="所属应急组织类型" prop="belongDeptType" style="display:inline-block;">
          <el-radio-group
            v-model="ruleForm.belongDeptType"
            style="width:60rem;"
            v-bind:disabled="IsEdit"
            @input="radioChanaged"
          >
            <el-radio v-for="item in options" :key="item.code" v-model="item.code" :label="item.code" style="margin-top: 0.4rem;margin-bottom:0.4rem;">{{item.value}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属组织机构" prop="belongDeptId" style="display:inline-block;">
          <el-select
            v-model="ruleForm.belongDeptId"
            placeholder="请选择所属组织机构"
            v-bind:disabled="IsEdit"
            style="width:60rem;"
          >
            <el-option
              v-for="item in options2"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人移动电话" prop="contactNo" style="display:inline-block;">
          <el-input v-model="ruleForm.contactNo" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="title" style="display:inline-block;">
          <el-input v-model="ruleForm.title" style="width:60rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday" style="display:inline-block;">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="ruleForm.birthday"
            style="width:60rem;"
            v-bind:disabled="IsEdit"
            format="yyyy-MM-dd" 
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="性别" prop="gender" style="display:inline-block;">
          <el-radio-group v-model="ruleForm.gender" style="width:60rem;" v-bind:disabled="IsEdit">
            <el-radio v-for="item in options3" :key="item.code" v-model="item.code" :label="item.code">{{item.value}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否负责人" prop="responsibleFlag" style="display:inline-block;">
          <el-radio-group v-model="ruleForm.responsibleFlag" style="width:60rem;" v-bind:disabled="IsEdit">
            <el-radio v-for="item in options4" :key="item.code" v-model="item.code" :label="item.code">{{item.value}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="简介" prop="intro" style="display:inline-block;">
          <el-input
            type="textarea"
            v-model="ruleForm.intro"
            style="width:60rem;"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
      </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="text-align:center;">
        <el-button v-if="opentype" @click="onClose()">返回</el-button>
        <template v-else>
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
          <el-button @click="resetForm()" v-show="IsEdit==false">重置</el-button>
        </template>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
  
</template>
<script>
import ZJApp from '../../../../../app';
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { save, update, detail } from "@/api/src/emergency_person";
import { list } from "@/api/src/emergency_organization";

import dayjs from 'dayjs'

export default {
  name: "ZjAddressbookinfo",
  controller: "EmergencyResource",
  action: "Addressbookinfo",
  props: {
    isHeadVisiable: { type: Boolean, default: true },
    opentype: { type: Boolean, default: false },
    query: {
      type: String,
      id: String,
      belongDeptType: String
    }
  },
  data() {
    return {
      ruleForm:{
        name: "",
        belongDeptType: this.query.belongDeptType,
        belongDeptId: "",
        contactNo: "",
        title: "",
        gender: 1,
        responsibleFlag: 0,
        birthday: dayjs(new Date()).format('YYYY-MM-DD'),
        age: "",
        intro: ""
      },
      options: [],
      options2: [],
      options3: [],
      options4: [],
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 15, message: "长度在 1 到 15 个字符", trigger: "blur" }
        ],
        belongDeptType: [
          {
            required: true,
            message: "请选择所属应急组织类型",
            trigger: "charge"
          }
        ],
        belongDeptId: [
          { required: true, message: "请选择组织结构", trigger: "charge" }
        ],
        contactNo: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
        ],
        responsibleFlag: [
          { required: true, message: "请输入是否负责人", trigger: "charge" }
        ],
        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  watch: {
    opentype(newV) {
      if (newV) {
        this.IsEdit = newV;
      }
    },
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          name: "",
          age: "",
          belongDeptType: this.query.belongDeptType,
          belongDeptId: "",
          contactNo: "",
          title: "",
          birthday: dayjs(new Date()).format('YYYY-MM-DD'),
          gender: 1,
          responsibleFlag: 0,
          intro: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  created: function() {
    this.basedatabind();
    this.search();
    this.IsEdit = this.query.type == "edit" ? false : true;
    if (this.opentype) {
      this.IsEdit = this.opentype;
    }
  },
  mounted: function() {},
  methods: {
      //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        getDictionary('organization_type'),
        getDictionary('gender_group'),
        getDictionary('yes_no'),
        this.SearchOrginze(this.query.belongDeptType),
      ])
      .then(r => {
        this.options = r[0].data.records;
        this.options3 = r[1].data.records;
        this.options4 = r[2].data.records;
        this.loading = false;
        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });
    },
    search() {
      let { id } = this.query;
      if (id != null && id != "") {
        this.loading = true;
        this.loadingText = '加载中...';
        detail( id )
          .then(r => {
            r = r.data;
            r.birthday = r.birthday ? r.birthday.split(' ')[0] : ''
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    radioChanaged(val) {
      console.log(val, this.ruleForm.belongDeptType)
      this.ruleForm.belongDeptId = ''
      this.options2 = []
      this.SearchOrginze(val);
    },
    async SearchOrginze(organizationType) {
      //所属组织结构
      let searchInfo = {
        organizationType,
        size: 999,
        current: 1,
      };
      let r = await list(searchInfo)
      r = r.data;
      this.options2 = r.records;
      return r
    },

    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    onClose() {
      this.$emit("onClose", {});
    },
    //重置
    resetForm() {
      //this.ruleForm = '';
      this.ruleForm ={
        name: "",
        age: "",
        belongDeptType: this.query.belongDeptType,
        belongDeptId: "",
        contactNo: "",
        title: "",
        birthday: dayjs(new Date()).format('YYYY-MM-DD'),
        gender: 1,
        responsibleFlag: 0,
        intro: ""
      };
      //this.$refs[formName].resetFields();
      this.query.id = null;
    },
    save() {
      let ruleForm = this.ruleForm
      ruleForm.belongDeptType = ruleForm.belongDeptType.toString();
      ruleForm.birthday = ruleForm.birthday + ' 00:00:00';
      console.log(ruleForm);
      if (this.query.id == null) {
        save(ruleForm).then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        update(ruleForm).then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>